import { ApolloClient, createHttpLink, InMemoryCache, gql } from "@apollo/client";
import {setContext} from '@apollo/client/link/context'

const httpLink = createHttpLink({
    uri: process.env.REACT_APP_URL_GRAPH,
});

const authLink = setContext((_, { headers }) => {
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        'X-API-KEY': process.env.REACT_APP_APIKEY_GRAPH,
      },
    }
});

export const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache()
});

export const getByCodePostal = async (ZipPostal) => {
    const querySuburb = gql`
      query obtainSuburb {
        obtainSuburbByZipCode(input: {cp: "${ZipPostal}"}) {
          code
          message
          result {
            asentamiento
            ciudad
            cp
            estado
            id
            municipio
            pais
            tipoAsentamiento
          }
        }
      }`;
  
      try{
  
        const response = await  client.query({
          query: querySuburb
        });
  
        if(response.data.obtainSuburbByZipCode.code === 200){
          var dataCodePostal = response.data.obtainSuburbByZipCode.result;
          return dataInformation(dataCodePostal);
        }else{
          return dataInformation("error");
        }
  
      }catch (error) {
        return dataInformation("error");
      }
  }

  export const getBranchByZC = async (ZipCode) => {
    const isPostalCode = true;
    const distance = 20;
    const queryBranch = gql`
      query obtainBranch {
        obtainBranchByZipCode(input: {isPostalCode: ${isPostalCode}, longDistance: ${distance}, postalCode: "${ZipCode}"}) {
          code
          message
          response {
            branchOffices{
              id
              branchOfficeName
            }
          }
        }
      }`;
  
      try{
  
        const result = await client.query({
          query: queryBranch
        });
  
        if(result.data.obtainBranchByZipCode.code === 200){
          var dataBranch= result.data.obtainBranchByZipCode.response.branchOffices;
          return dataInformation(dataBranch);
        }else{
          return dataInformation("error");
        }
      }catch (error) {
        return dataInformation("error");
      }
  }
  

  export const getCollaborators = async (idBranch) => {
    const queryCollaborators = gql`
      query obtainCollaborators {
        obtainCollaboradorBranch(idBranch: "${idBranch}") {
          code
          message
          result {
            id
            name
            idFunction
            function
            idStatusEmployee
            statusEmployee
          }
        }
      }`;
  
      try{
        const response = await client.query({
          query: queryCollaborators
        });
  
        if(response.data.obtainCollaboradorBranch.code === 200){
          var dataCollaborator= response.data.obtainCollaboradorBranch.result;
          return dataInformation(dataCollaborator);
        }else{
          return dataInformation("error");
        }
      }catch (error) {
        return dataInformation("error");
      }
  }
  
  const dataInformation = (datac) => {
    return datac;
  } 